import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function FollowButton({ slug, name, size = "sm", onChange }) {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const following = !!user?.watchlist?.includes(slug);
  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post("/watchlist/toggle", { slug });
      setUser((u) => ({ ...u, watchlist: data.watchlist }));
      onChange?.(data.following);
      toast.success(data.following ? `Following ${name || "player"} — streaks and props will surface on your dashboard` : `Unfollowed ${name || "player"}`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const cls = size === "lg" ? "gap-2 px-4 py-2 text-xs" : "gap-1 px-2 py-1 text-[10px]";
  return (
    <button data-testid="follow-btn" data-following={following} aria-label={following ? "Unfollow" : "Follow"} disabled={busy} onClick={toggle}
      className={`inline-flex items-center rounded-full border font-bold uppercase tracking-wider transition-[background-color,border-color,transform] duration-200 hover:-translate-y-0.5 ${cls} ${following ? "border-amber-400/60 bg-amber-400/15 text-amber-300" : "border-[#26334D] text-slate-400 hover:border-amber-400/60 hover:text-amber-300"}`}>
      <Star size={size === "lg" ? 14 : 11} className={following ? "fill-amber-300" : ""} /> {following ? "Following" : "Follow"}
    </button>
  );
}
